import { LookupModelSearchEvent } from "@mcleod/components/src/events/LookupModelSearchEvent";
import { AutogenLayoutDispatchControl } from "./autogen/AutogenLayoutDispatchControl";
import { ChangeEvent, ClickEvent, DropdownSelectionEvent } from "@mcleod/components";
import { Api, CurrencySettings, Model } from "@mcleod/core";

export class DispatchControl extends AutogenLayoutDispatchControl {

    async onLoad(): Promise<void> {
        //this.panelLMCheckboxes.style.setProperty("flex-direction", "row");
        const currencySettings = CurrencySettings.getSingleton();
        const multiCurrencyEnabled = currencySettings.multiCurrencyEnabled();
        const arControl = await Model.searchSingleRecord("lme/ar/arcontrol");
        if (arControl?.get("is_dedicated_active", "N") === "Y") {
            this.tabDedicatedBilling.visible = true;
            this.checkboxIncludeDedicatedChoice.visible = true;
        } else {
            this.tabDedicatedBilling.visible = false;
            this.checkboxIncludeDedicatedChoice.visible = false;
        }

        if(multiCurrencyEnabled) {
            this.labelHOSHeader.text = "Hours of Service Rules";
            this.labelUSARules.text = "United States (70/8)";
        } else {
            this.labelHOSHeader.text ="Hours of Service Rules";
            this.labelUSARules.text = "United States";
        }
    }

    claimAcknowledgementFormatBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "L";
        event.filter.template_number = ">0";
    }

    textboxPositionDisplayAfterDropdownSelection(event: DropdownSelectionEvent){
        const apiRow = this.mainDataSource.activeRow;
        const positionDisplay = apiRow.get("position_display", "");
        const positionFormat = apiRow.get("position_format", "");
        Api.post("lme/dispatch/update-position-format", { position_display: positionDisplay, position_format: positionFormat }).then((result) => {
            const apiData = result.data[0];
            if (apiData) {
                this.labelPosition.text = apiData.position_label;
            }
        });
    }

    /** This is an event handler for the onChange event of switchInclInspectTime. */
    switchInclInspectTimeOnChange(event: ChangeEvent) {
        if (this.switchInclInspectTime.checked) {
            this.textboxInspectTime.required = this.textboxInspectTime.enabled = true;
        } else {
            this.textboxInspectTime.required = this.textboxInspectTime.enabled = false;
        }
    }

    /** This is an event handler for the onChange event of switchInclRefuelTime. */
    switchInclRefuelTimeOnChange(event: ChangeEvent) {
        if (this.switchInclRefuelTime.checked) {
            this.textboxFuelDistance.required = this.textboxFuelDistance.enabled = true;
            this.textboxRefuelTime.required = this.textboxRefuelTime.enabled = true;
        } else {
            this.textboxFuelDistance.required = this.textboxFuelDistance.enabled = false;
            this.textboxRefuelTime.required = this.textboxRefuelTime.enabled = false;
        }
    }

    checkboxDriverPTAOnChange(event: ChangeEvent) {
        if (event.domEvent != null) {
            this.checkboxRecordPtaWeb.checked = !this.checkboxRecordPta.checked;
        }
    }

    checkboxDriverPTAWebOnChange(event: ChangeEvent) {
        if (event.domEvent != null) {
            this.checkboxRecordPta.checked = !this.checkboxRecordPtaWeb.checked;
        }
    }

    /** This is an event handler for the onChange event of switchEnableAutoHome. */
    switchEnableAutoHomeOnChange(event: ChangeEvent) {
        this.panelAutoHomeFields.visible = this.switchEnableAutoHome.checked;
    }
}

